import config from './config';
import blocks from './blocks/index';
import combineBlocks from './combineBlocks';

var __eventTypes = {
  Ready: 'ready',
  Click: 'aa-link',
};

function __outputContentSection(dl) {
  return dl && dl.content_section ? ' (content_section: ' + dl.content_section + ')' : '';
}

// Trigger has NO notion of an $el, so ALL blocks need to be provided
// via the event that is taking place
export default function anTrigger(event, allBlocksArr) {
  var fireTagEvent = event;
  var global;

  // Use the old get global version which isn't good
  // as its affected by external forces, IE: inline data-layers and the like
  if (config.oldGlobal) {
    if (window.dataLayerBAT && window.dataLayerBAT.utils) {
      global = window.dataLayerBAT.utils.getGlobalBlock();
      delete global.metrics;
      delete global.fireTagShortPhrase;
    } else {
      global = {};
    }
  }
  // for testing: send only our relevant dataLayer
  if (!config.oldGlobal) {
    global = blocks.globalBlock();
  }

  var dataLayer = $.extend(global, combineBlocks(allBlocksArr));

  // click events use keymetric as event, if we have a keymetric
  if (event === __eventTypes.Click && dataLayer.metrics && dataLayer.metrics.length) {
    fireTagEvent = dataLayer.metrics;
  }

  // NOTE that we are NOT updating window.dataLayerBAT.data at all
  if (config.debug && config.debug.trigger) {
    console.group('DL 1.5: ' + fireTagEvent + __outputContentSection(dataLayer));
    // BAT-7084 switched from table to log because IE11 throwing error and not loading header
    console.log(dataLayer);
    console.groupEnd();
  }

  // trigger firetag or queue if not present (tagms/bootstrap.js is deferred in <head>)
  window.__analytics_queue__ = window.__analytics_queue__ || [];
  if (typeof window.fireTag === 'function' && window.__analytics_queue__.length === 0) {
    window.fireTag(fireTagEvent, dataLayer);
  } else {
    window.__analytics_queue__.push({
      id: fireTagEvent,
      data: dataLayer
    });
  }
}
